import { ReportMetric, ReportValue, Team, User } from '@driftt/api-types'
import { AvailabilityIF } from '@driftt/app-config/dist/utils/driftTypes'

import { IQueryOptions } from 'api/report/query/types'

export type ParserFunction<T = any, K = any> = (
  response: T,
  queryConfig: IRealTimeQueryConfig,
  options?: IQueryOptions
) => K

export interface IRealTimeQueryConfig {
  metric: string
  value?: ReportValue | ReportValue[]
  botId?: number
  botStatus?: string
  compoundQuery?: any
  teamSelected?: Team[]
  workspaceAgents?: { value: ReportValue }[]
  agentsSelected?: { value: ReportValue }[]
  widgetStatus?: string
  inboxSelected?: number
  classificationId?: number
  metrics?: ReportMetric[]
  timezone?: string
  playbookVersion?: number
}

export interface IRealTimeExport {
  query: IRealTimeQueryConfig
  columns: string[]
}

export interface IRealTimeTicketQueryConfig {
  orgId: number
  timezone?: string
}

export interface TopHitsRow {
  metrics: number[][]
  dimensions: any[]
}

export interface SimpleReportRow {
  metrics: number[]
  dimensions: any[]
}

export type LeadsQualified = Record<string, LeadsQualifiedCounts>

export interface LeadsQualifiedCounts {
  isParticipantCount: number
  otherCount: number
  total: number
}

export enum ConversationFeedMetrics {
  CSAT = 'lowCsatByDay',
  MISSED = 'missedChatsByType',
}

export enum ConversationFeedSearchMetrics {
  CSAT = 'lowCsatSearch',
  MISSED = 'missedChatsSearch',
}

export enum RoutingFallbackTypes {
  OFFLINE = 'OFFLINE',
  REROUTE = 'REROUTE_WITHIN_TEAM',
  TICKET = 'TICKET_CREATED',
  AWAY = 'AWAY_MESSAGE',
  MEETING = 'CALENDAR_DROP',
}

export type PatchFeedConversation = (convoId: number, extraDetails: any) => void

export interface ConversationFeedItem {
  id: number
  reason?: RoutingFallbackTypes
  rating?: number
  type: string
}

export interface ConversationFeedItemDetails {
  ratedAt?: number
  ratingText?: string
  timestamp?: number
  endUserId?: string
  agentId?: string
  agent?: User
  agentName?: string
  messageId: string | null
}

export type ConversationFeedItemWithDetails = ConversationFeedItem &
  ConversationFeedItemDetails

type RatingValue = 1 | 2 | 3 | 4 | 5
export interface Message {
  authorId: number
  authorType: string
  type: string
  createdAt: number
  conversationEvent?: {
    createdAt: number
    currentParticipantIds: number[]
    participantIds: number[]
    type: string
    meetingInitiatedType?: string
    participantChangeType?: string
  }
  attributes: {
    fromUnresponsiveFallback?: boolean
    onBehalfOfAgentId?: number
    ratingPrompt?: {
      ratingPromptMessage: string
    }
    conversationRating?: {
      ratingPrompt: {
        ratingAcknowledgement: string
        ratingPromptMessage: string
      }
      ratingValue?: RatingValue
      ratingText?: string
    }
  }
}

export interface SWRUser extends User {
  availability?: AvailabilityIF
}

export enum RTDReportTypes {
  LOW_CSAT = 'lowCsatByDay',
  LOW_CSAT_SEARCH = 'lowCsatSearch',
  NOT_RESPONDED = 'totalRoutedNotRespondedTeamConversations',
  REP_PERFORMANCE = 'realTimeRepPerformance',
  CHAT_RATINGS = 'liveChatRatingsByRep',
  OPEN_CLOSED_CONVOS = 'openAndClosedConvos',
  MISSED_CHATS_AGENT = 'missedChatsByAgent',
  MISSED_CHATS_TYPE = 'missedChatsByType',
  MISSED_CHATS_SEARCH = 'missedChatsSearch',
  LEADS = 'leadsQualifiedByAgent',
  LEADS_SEARCH = 'leadsQualifiedSearch',
  TOTAL_CONVOS = 'totalConvosByAgent',
  MEETINGS_BOOKED = 'meetingsBookedByAgent',
}
